import React, { useEffect, useState } from "react"
import "../App.css"
import { Table } from "react-bootstrap"


class HoymilesInfo {
  constructor(
    readonly dtuPower: number,
    readonly dtuDailyEnergy: number,
    readonly eastPanel: HoymilesPanelInfo,
    readonly southPanel: HoymilesPanelInfo
  ) {}

  formatPower(): string {
    return (this.dtuPower / 10).toFixed(1)
  }
}

class HoymilesPanelInfo {
  constructor(
    readonly portNumber: number,
    readonly power: number,
    readonly energyDaily: number,
    readonly energyTotal: number
  ) {}

  formatPower(): string {
    return (this.power / 10).toFixed(1)
  }
}

export default function DtuInfo() {
  const [hoymilesInfo, setHoymilesInfo] = useState<HoymilesInfo | undefined>()

  const hoymilesGateway = "192.168.0.83:3000"

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `http://${hoymilesGateway}/data.json`,
      )
      const json = await response.json()
      console.log("Fetched hoymiles info , ", json)
      const panel1 = new HoymilesPanelInfo(
        json.pvData[0].portNumber,
        json.pvData[0].power,
        json.pvData[0].energyDaily,
        json.pvData[0].energyTotal
      )
      const panel2 = new HoymilesPanelInfo(
        json.pvData[0].portNumber,
        json.pvData[1].power,
        json.pvData[1].energyDaily,
        json.pvData[1].energyTotal
      )
      const eastPanel = panel1.portNumber == 2 ? panel1 : panel2
      const southPanel = panel1.portNumber == 1 ? panel1 : panel2
      setHoymilesInfo(new HoymilesInfo(
        json.dtuPower,
        json.dtuDailyEnergy,
        eastPanel,
        southPanel
      ))
    }

    fetchData().catch(console.error)
  }, [])

  return (
    <>
      <Table striped hover>
        <tbody>
          <tr>
            <td>
              Power
            </td>
            <td>
              {hoymilesInfo?.formatPower()} Watt
            </td>
          </tr>
          <tr>
            <td>
              Daily energy
            </td>
            <td>
              {hoymilesInfo?.dtuDailyEnergy} Watt⋅h
            </td>
          </tr>
        </tbody>
      </Table>  
      <Table striped hover>
        <tbody>
        <tr>
          <td>
            Panel
          </td>
          <td>
            East
          </td>
          <td>
            South
          </td>
        </tr>
        <tr>
          <td>
            Power
          </td>
          <td>
            {hoymilesInfo?.eastPanel?.formatPower()} Watt
          </td>
          <td>
            {hoymilesInfo?.southPanel?.formatPower()} Watt
          </td>
        </tr>
        <tr>
          <td>
            Daily energy
          </td>
          <td>
            {hoymilesInfo?.eastPanel?.energyDaily} Watt⋅h
          </td>
          <td>
            {hoymilesInfo?.southPanel?.energyDaily} Watt⋅h
          </td>
        </tr>
        <tr>
          <td>
            Total energy
          </td>
          <td>
            {hoymilesInfo?.eastPanel?.energyTotal} Watt⋅h
          </td>
          <td>
            {hoymilesInfo?.southPanel?.energyTotal} Watt⋅h
          </td>
        </tr>
        </tbody>
      </Table>  
    </>
  )
}


export function DtuPanelInfo(props: {
  panelInfo: HoymilesPanelInfo,
  label: string
}) {
  return <>
    <tr>
      <td>
        Panel
      </td>
      <td>
        {props.label}
      </td>
    </tr>
    <tr>
      <td>
        Power
      </td>
      <td>
        {props.panelInfo?.formatPower()} Watt
      </td>
    </tr>
    <tr>
      <td>
        Daily energy
      </td>
      <td>
        {props.panelInfo?.energyDaily} Watt⋅h
      </td>
    </tr>
    <tr>
      <td>
        Total energy
      </td>
      <td>
        {props.panelInfo?.energyTotal} Watt⋅h
      </td>
    </tr>
  </>
}
